import candidateCertificate from '@/api/academic/candidate-certificate';

import { baseState, baseMutations } from '@/store/mixins';
import { join, split } from 'lodash';
import moment from 'moment'

export const state = {
    ...baseState,
    formViewDatas: [],
    dateRange: [
        moment()
            .add(-7, 'days')
            .format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY')
    ]
}
export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    },
    SET_DATE_RANGE(state, date) {
        state.dateRange = date
    },
}
export const getters = {
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search,
                    date_between: join(context.state.dateRange, ','),
                }
            },
            attrubutes
        )
        return candidateCertificate.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    async getFormViewData(context, { params, index }) {
        let response = await candidateCertificate.formModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
}
